import { useEffect } from 'react';

function useOutsideClickDropdown(ref, handleDropdown, setShowDropdown = null) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleDropdown();
        if(setShowDropdown) setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export default useOutsideClickDropdown;
